import React from 'react';
import Icon from '../../../components/AppIcon';

const EarningsOverview = ({ data }) => {
  const maxRevenue = Math.max(...(data?.monthlyData?.map(d => d?.revenue) || [0]));

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading text-2xl font-semibold text-foreground flex items-center space-x-2">
          <Icon name="TrendingUp" size={24} strokeWidth={2} className="text-primary" />
          <span>Earnings Overview</span>
        </h2>
        <select className="px-4 py-2 border border-border rounded-md font-body text-sm focus:outline-none focus:ring-2 focus:ring-primary">
          <option>Last 3 Months</option>
          <option>Last 6 Months</option>
          <option>Last Year</option>
        </select>
      </div>

      {/* Key Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-primary/5 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <p className="font-caption text-sm text-muted-foreground">Monthly Revenue</p>
            <Icon name="DollarSign" size={18} className="text-primary" strokeWidth={2} />
          </div>
          <p className="font-heading text-2xl font-bold text-foreground">${data?.monthlyRevenue}</p>
          <p className="font-caption text-xs text-success flex items-center space-x-1 mt-1">
            <Icon name="TrendingUp" size={12} strokeWidth={2} />
            <span>+23% from last month</span>
          </p>
        </div>

        <div className="bg-accent/5 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <p className="font-caption text-sm text-muted-foreground">Total Bookings</p>
            <Icon name="Calendar" size={18} className="text-accent" strokeWidth={2} />
          </div>
          <p className="font-heading text-2xl font-bold text-foreground">{data?.totalBookings}</p>
          <p className="font-caption text-xs text-success flex items-center space-x-1 mt-1">
            <Icon name="TrendingUp" size={12} strokeWidth={2} />
            <span>+5 this month</span>
          </p>
        </div>

        <div className="bg-success/5 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <p className="font-caption text-sm text-muted-foreground">Pending Payouts</p>
            <Icon name="Wallet" size={18} className="text-success" strokeWidth={2} />
          </div>
          <p className="font-heading text-2xl font-bold text-foreground">${data?.pendingPayouts}</p>
          <p className="font-caption text-xs text-muted-foreground mt-1">Due Feb 15</p>
        </div>

        <div className="bg-warning/5 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <p className="font-caption text-sm text-muted-foreground">Average Rating</p>
            <Icon name="Star" size={18} className="text-warning fill-warning" strokeWidth={2} />
          </div>
          <p className="font-heading text-2xl font-bold text-foreground">{data?.averageRating}</p>
          <p className="font-caption text-xs text-muted-foreground mt-1">Based on 47 reviews</p>
        </div>
      </div>

      {/* Revenue Chart */}
      <div>
        <h3 className="font-body font-semibold text-foreground mb-4">Monthly Revenue Trend</h3>
        <div className="flex items-end justify-between space-x-4 h-48">
          {data?.monthlyData?.map((month, index) => (
            <div key={index} className="flex-1 flex flex-col items-center">
              <div className="w-full flex items-end justify-center h-40 mb-2">
                <div
                  className="w-full bg-gradient-to-t from-primary to-primary/60 rounded-t-md transition-all duration-500 hover:opacity-80 relative group"
                  style={{ height: `${(month?.revenue / maxRevenue) * 100}%` }}
                >
                  <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-foreground text-background px-2 py-1 rounded text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                    ${month?.revenue}
                  </div>
                </div>
              </div>
              <p className="font-caption text-sm text-muted-foreground">{month?.month}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EarningsOverview;